import { render, staticRenderFns } from "./S3F.vue?vue&type=template&id=7a67239c&scoped=true&"
import script from "./S3F.vue?vue&type=script&lang=js&"
export * from "./S3F.vue?vue&type=script&lang=js&"
import style0 from "./S3F.vue?vue&type=style&index=0&id=7a67239c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a67239c",
  null
  
)

export default component.exports